import { Capacitor } from "@capacitor/core";
import { memoize } from "decko";
import PlatformTypes from "const/PlatformTypes";

const CHROMIUM_BROWSER_PATTERN = /Chrome|Chromium|Edg|OPR/;

export default class Platforms {
  @memoize
  static getMobileType() {
    if (/Android/i.test(window.navigator.userAgent)) {
      return PlatformTypes.ANDROID;
    }
    if (/iPad|iPhone|iPod|CriOS/.test(window.navigator.userAgent) && !window.MSStream) {
      return PlatformTypes.IOS;
    }

    return null;
  }

  @memoize
  static getNativeType() {
    return Platforms.checkIsNative() ? Capacitor.getPlatform() : null;
  }

  @memoize
  static checkIsTouchDevice() {
    return "ontouchstart" in window;
  }

  @memoize
  static checkIsChromiumBrowser() {
    return CHROMIUM_BROWSER_PATTERN.test(window.navigator.userAgent);
  }

  @memoize
  static checkIsNative() {
    return Capacitor.isNativePlatform();
  }

  @memoize
  static checkIsNativeAndroid() {
    return Platforms.getNativeType() === PlatformTypes.ANDROID;
  }

  @memoize
  static checkIsNativeIos() {
    return Platforms.getNativeType() === PlatformTypes.IOS;
  }
}
